import { useRouteError } from 'react-router-dom';
import ErrorPage from './Error';

export const errorTypes = {
  FormNotFound: 'FormNotFound',
};

const Error = () => {
  const error = useRouteError() || {};
  console.log('ERROR--', error);
  const Component = ErrorPage;
  return (
    <Component error={error} />
  );
};

export default Error;
